import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterContentInit, AfterViewInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { IonDatetime, IonModal, ModalController } from "@ionic/angular";
import { ModalScheduleComponent } from "./modal-schedule/modal-schedule.component";
import { element } from 'protractor';
import { DatePipe } from '@angular/common';

export enum TypeRace {
  OneWay = 0,
  RoundTrip = 1,
  Schedule = 2
}

@Component({
    selector: "app-type-race",
    templateUrl: "./type-race.component.html",
    styleUrls: ["./type-race.component.scss"],
    standalone: false
})
export class TypeRaceComponent implements OnInit, AfterContentInit, AfterViewInit {
  @Input() controlForm: UntypedFormGroup;
  @Output() sendDateSchedule = new EventEmitter();
  checkEnabledDate = true;
  @Output() sendRaceType = new EventEmitter();
  @ViewChild("gambys", { static: false }) gambys: HTMLElement;
  @ViewChild("dateTime", { static: false }) ionDateTime: IonDatetime;
  @ViewChild(IonModal) modal: IonModal;
  isSchedule = false;
  dateNow = new Date();
  maxDate = new Date().setFullYear(this.dateNow.getFullYear() + 1);
  stringDate = this.dateNow.toISOString();
  optionsItem = [
    { label: "One Way", value: TypeRace.OneWay, selected: false },
    { label: "Round Trip", value: TypeRace.RoundTrip, selected: false },
    { label: "Schedule", value: TypeRace.Schedule, selected: false }
  ];

  selected: number = 0;

  constructor(public modalCtrl: ModalController, private datePipe: DatePipe) {
  }
  ngAfterViewInit(): void {
    this.dateNow.setDate(this.dateNow.getDate());
    this.dateNow.setHours(this.dateNow.getHours() + 1);
    this.ionDateTime.value = this.datePipe.transform(this.dateNow, 'yyyy-MM-ddTHH:mm:ss');
  }

  ngAfterContentInit(): void {
  }

  ngOnInit() {
  }

  async showModalSchedule() {
    const modal = await this.modalCtrl.create({
      component: ModalScheduleComponent,
      cssClass: "modal-theme"
    });

    return await modal.present();
  }

  async setOption(option, index): Promise<void> {

    if (option.value !== TypeRace.Schedule) {
      this.selected = index;
    } else {
      this.optionsItem[2].selected = !this.optionsItem[2].selected;
      if (!this.optionsItem[2].selected) {
        this.sendDateSchedule.emit(null);
        this.checkEnabledDate = true;
      } else {
        await this.modal.present();
      }
    }

    if (option.value == TypeRace.Schedule && this.checkEnabledDate) {
      // this.gambys.click();
    }

    this.sendRaceType.emit(option.value);
    this.controlForm.setValue(option.value);
  }

  emitDate(event) {
    console.log(this.ionDateTime);
    let date = new Date(event.detail.value);
    const currentDate = new Date();
    //if date is less than or equal current date, set date to current date plus 1 hour
    if (date <= currentDate) {
      date = currentDate;
      date.setHours(date.getHours() + 1);
    }
    this.sendDateSchedule.emit(date);
    this.checkEnabledDate = false;
  }

  getDateFormat(): string {
    const currentDate = new Date();
    const futureDate = new Date(currentDate);
    futureDate.setDate(currentDate.getDate() + 20);
    return futureDate.getFullYear() == currentDate.getFullYear() ? "D MMM h:mm A" : "D MMM YYYY h:mm A"
  }
}
